import React, { useState, useRef, useEffect } from "react";
import { FaUser } from "react-icons/fa6";
import { IoLogOutOutline } from "react-icons/io5";
import { RiArrowDropDownLine } from "react-icons/ri";
import { Link, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { fetchAdminProfile } from "../redux/adminReducer";

function DropdownAdmin({ setUser }) {
  const { lang , translations } = useSelector((state) => state.language); 
  const isRtl = lang === "ar";
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef();
  const navigate = useNavigate();

  const dispatch = useDispatch();
  const { profile } = useSelector((state) => state.admin.admin);
  const image = profile?.profilePicture;
  
  useEffect(() => {
    dispatch(fetchAdminProfile());
  }, [dispatch]);

  const BASE_URL = process.env.REACT_APP_BASE_URL || "https://jeema.co/api/v2/";
  const profilePic = profile?.profilePicture
    ? `${BASE_URL}${encodeURIComponent(
      profile?.profilePicture
    )}`
    : "/images/bg-images/user-profile.jpg";

  
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const handleLogout = () => {
    localStorage.removeItem("token");
    localStorage.removeItem("user");
    localStorage.removeItem("lang");
    if (setUser) setUser(null);
    navigate("/login");
  };

  return (
    <div
      className={`relative inline-block ${isRtl ? "right-0 " : "left-0 "}`}
      ref={dropdownRef}
    >
      <div
        onClick={() => setIsOpen(!isOpen)}
        className="flex items-center gap-1 cursor-pointer text-white m-2"
      >
        <RiArrowDropDownLine className="text-2xl" />
        <span>{profile?.name}</span>
        <img
          src={profilePic}
          alt="User Profile"
          className="rounded-full w-8 h-8 object-cover "
        />
      </div>

      {isOpen && (
        <div
          className={`absolute top-full mt-2 w-[150px]  bg-gray-800 rounded-md shadow-lg z-50  ${
            isRtl ? "right-0" : "left-0"
          }`}
          style={{
            maxHeight: "300px",
            overflow: "auto",
            margin: isRtl ? "0 -30px 0 0" : "0 0 0 -30px", 
          }}
        >
          <Link
            to="/profile-settings"
            className={`flex items-center no-underline px-4 py-2 my-2 text-white hover:bg-gray-700`}
          >
            <FaUser className={`${isRtl ? "ml-2" : "mr-2"}`} />
            {translations.header.profile}
          </Link>
          <hr className="my-1" />
          <span
            onClick={handleLogout}
            className="w-full flex items-center px-4 py-2 my-2 text-white hover:bg-gray-700"
          >
            <IoLogOutOutline className={`${isRtl ? "ml-2" : "mr-2"}`} />
            {translations.header.logout}
          </span>
        </div>
      )}
    </div>
  );
}

export default DropdownAdmin;
